import React, { useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Clear as ClearIcon } from '@mui/icons-material'
import { useStyles } from './SlidesStyles'
import { saveReportData, setPDFBytes } from '../../actions'
import ReportPreview from '../CaseDiagnosis/ReportGenerator/ReportPreview'
export default function ReleasePrimaryReport({
  isReleasePrimaryReportOpen,
  handleReleasePrimaryReportClose,
  trfBarcode,
  pdfUrl,
  setPdfUrl,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const getCPTCodes = useSelector((state: RootState) => state.getCPTCodesData)
  const [cptCodes, setCPTCodes] = useState([] as any)
  const [isLoading, setLoading] = useState(false)
  const { userLogin, name } = useSelector((state: RootState) => state.userLogin)
  const pdfUrlData = useSelector((state: RootState) => state.getPDFBytes)
  const draftData = useSelector((state: RootState) => state.setDraftReportData)
  const { workflowId, procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const [pdfFlag, setPdfFlag] = useState(true)
  const [isReportLoaded, setReportLoaded] = useState(false)
  const [changedCodes, setChangedCodes] = useState(getCPTCodes.payload)
  const getCellClass = (isDontReport) => (isDontReport ? classes.disabledTableCell : classes.tableCell)
  const getCheckboxClass = (isDontReport) => (isDontReport ? classes.disabledCheckbox : classes.checkBox)
  const getButtonClassName = () =>
    isReportLoaded ? `${classes.buttonMargin} ${classes.saveButton}` : `${classes.disableBtn}`
  useEffect(() => {
    if (trfBarcode && getCPTCodes) {
      setCPTCodes(getCPTCodes.payload)
    }
  }, [trfBarcode, getCPTCodes])

  useEffect(() => {
    if (pdfFlag && pdfUrlData && pdfUrlData.payload && pdfUrlData.payload.length > 0) {
      setPdfUrl(pdfUrlData.payload + '#zoom=75&')
      setPdfFlag(false)
    }
  }, [pdfUrlData, pdfFlag])

  useEffect(() => {
    if (pdfUrl) {
      setReportLoaded(true)
    } else {
      setReportLoaded(false)
    }
  }, [pdfUrl])

  const handleUploadReport = async () => {
    setLoading(true)
    const savedCodes = [] as any
    if (changedCodes && changedCodes.length > 0) {
      changedCodes.map((item) => {
        if (item.PC === 1) item.PC = true
        else if (item.PC === 0) item.PC = false
        if (item.TC === 1) item.TC = true
        else if (item.TC === 0) item.TC = false
        savedCodes.push(item)
        return item
      })
    }
    await dispatch(
      saveReportData({
        trfBarcode: trfBarcode,
        cptCodes: savedCodes.length > 0 ? savedCodes : cptCodes,
        saveDraftJSON: draftData,
        reason: getReason(),
        diagnosisLP: { name: name, email: userLogin },
        consultLP: draftData.consultedPats && draftData.consultedPats.length > 0 ? draftData.consultedPats : [],
        calloutDecision: draftData.calloutDecision,
        procedureCode: procedureCodeId,
      }),
    )
  }

  const getReason = () => {
    switch (workflowId) {
      case 'CORRECT_ASSIGNED_READY':
        return 'corrected'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'corrected'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return 'publish'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_READY':
        return 'publish'
      case 'AMEND_INITIATED':
        return 'amended'
      case 'AMEND_RESULTED_RESULT_RELEASED':
        return 'amended'
    }
  }

  const handlePCChange = (event, index) => {
    changedCodes[index].PC = event.target.checked ? 1 : 0
    setChangedCodes(changedCodes)
  }

  const handleTCChange = (event, index) => {
    changedCodes[index].TC = event.target.checked ? 1 : 0
    setChangedCodes(changedCodes)
  }

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => setLoading(false), 7000)
    }
  }, [isLoading])

  const handleCancel = async () => {
    setCPTCodes(getCPTCodes.payload)
    setPdfUrl('')
    await dispatch(setPDFBytes({ pdfUrl: '' }))
    handleReleasePrimaryReportClose()
  }

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={isReleasePrimaryReportOpen} onClose={handleCancel}>
        <DialogTitle className={classes.dialogTitle}>Release Report</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ float: 'left', height: '495px' }} className={classes.reportHalfPreview}>
            <ReportPreview
              trfBarcode={trfBarcode}
              location={null}
              pdfUrl={pdfUrl}
              setPdfUrl={setPdfUrl}
              isRelease={true}
            />
          </div>
          <>
            <div>
              <h3 style={{ float: 'left' }}>CPT code selection </h3>
            </div>
            <TableContainer component={Paper} style={{ height: '430px', width: '40%', float: 'left' }}>
              <Table aria-label="customized table">
                <TableBody>
                  <TableRow style={{ backgroundColor: '#0d688d73' }}>
                    <TableCell className={classes.tableHeader}>Lbl</TableCell>
                    <TableCell className={classes.tableHeader}>Barcode</TableCell>
                    <TableCell className={classes.tableHeader}>Type</TableCell>
                    <TableCell className={classes.tableHeader}>Stain</TableCell>
                    <TableCell className={classes.tableHeader}>CPT</TableCell>
                    <TableCell className={classes.tableHeader}>P</TableCell>
                    <TableCell className={classes.tableHeader}>T</TableCell>
                  </TableRow>
                  {cptCodes &&
                    cptCodes.length > 0 &&
                    cptCodes.map((cptItem, index) => (
                      <TableRow key={index}>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>{cptItem.Lbl}</TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>{cptItem.Barcode}</TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>{cptItem.Type}</TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>{cptItem['IHC Status']}</TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>{cptItem['CPT Code']}</TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>
                          <Checkbox
                            className={getCheckboxClass(cptItem.isDontReport)}
                            onChange={(event) => handlePCChange(event, index)}
                            defaultChecked={cptItem.PC === 1 ? true : false}
                            value={cptItem.PC === 1 ? true : false}
                            disabled={cptItem.isDontReport}
                          />
                        </TableCell>
                        <TableCell className={getCellClass(cptItem.isDontReport)}>
                          <Checkbox
                            className={getCheckboxClass(cptItem.isDontReport)}
                            onChange={(event) => handleTCChange(event, index)}
                            defaultChecked={cptItem.TC === 1 ? true : false}
                            value={cptItem.TC === 1 ? true : false}
                            disabled={cptItem.isDontReport}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button onClick={handleUploadReport} className={getButtonClassName()}>
            Upload Report
          </Button>
          <Button
            className={`${classes.buttonMargin}`}
            variant="outlined"
            endIcon={<ClearIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
